export default __webpack_public_path__ + "static/media/Blue-lagoon.670fb561.png";